import { RHFDualSystemNumberInput } from "~/features/selectionAssistant/housing/components/Inputs/DualUnitNumberInput/DualSystemNumberInput";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { NumberSystem } from "~/features/selectionAssistant/housing/types/types";

interface SingleDimensionInputProps {
  className?: string;
  label?: string;
  mode: NumberSystem;
  name: string;
  mobile?: boolean;
}

export const SingleDimensionInput = ({ className, label, mode, name, mobile }: SingleDimensionInputProps) => {
  const unit = mode === NumberSystem.Metric ? "mm" : "inch";
  const { t } = useTranslation();
  const minLabel = `${t("searchPage.refinement.value.label.min")} (${unit})`;
  const maxLabel = `${t("searchPage.refinement.value.label.max")} (${unit})`;

  return (
    <div className={classNames("scha__dimensions-inputs", className)}>
      {label && <label className={"scha__dimensions-inputs__label"}>{t(label)}</label>}
      <div className={mobile ? "scha__dimensions-inputs-container" : ""}>
        <RHFDualSystemNumberInput
          mode={mode}
          label={minLabel}
          className={mobile ? "mr-2" : "mb-2"}
          name={`${name}.min`}
          data-test-id={`housing-sa-${name}-min`}
        />
        <RHFDualSystemNumberInput
          mode={mode}
          label={maxLabel}
          name={`${name}.max`}
          data-test-id={`housing-sa-${name}-max`}
        />
      </div>
    </div>
  );
};
